import styles from '../DeleteAccount/DeleteAccountPage/style.module.scss';

export const PROFILE_PICTURE_KVS_KEY = 'profile_picture';
export const CROP_AREA_ASPECT = 1 / 1;
export const deleteAccountDialogProps = { classes: { paper: styles.paper } };
